<template>
  <div class="doodoo-banner" @click="handlePoolClick">
    <div class="content">
      <div class="doodoo-banner__background-gradient">
        <img
          alt="background"
          class="image-gradient"
          src="@/assets/banners/purple-background.svg"
        />
      </div>
      <img
        alt="returd-and-doodoo-coin"
        class="doodoo-banner__logo"
        src="@/assets/banners/doodoo-banner.png"
      />
      <div class="doodoo-banner__item">
        <p class="doodoo">{{ $t('swap.doodoo') }}</p>
        <p class="aptos">{{ $t('swap.apt') }}</p>
      </div>
    </div>
    <div class="doodoo-banner__item tvl-block">
      <p class="tvl">
        {{ $t('pools.tvl') }}
      </p>
      <p class="tvl-value">{{ tvl ? `$${tvl}` : '-' }}</p>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { amount2NoENotation } from '@/composables/useInputServices';
import { computed, inject } from 'vue';
import { DOODOO } from '@/constants/tokens';
import { APTOS, VERSION_0_5 } from '@/constants';
import { CURVE_UNSTABLE_V05 } from '@/constants/networks';
import { usePoolsStore } from '@/store';
import { useRouter } from 'vue-router';
import { EMixpanelEventNames, EMixpanelProvideKeys } from '@/types/enums';
import { Track } from '@/types';

const poolsStore = usePoolsStore();
const router = useRouter();
const track = inject(EMixpanelProvideKeys.Track) as Track;
const poolData = computed(() =>
  poolsStore.getPoolFromMap(DOODOO, APTOS, CURVE_UNSTABLE_V05, 0.5),
);

const tvl = computed(() => {
  const _tvl = poolData.value?.tvl;
  return _tvl && !Number.isNaN(_tvl) && String(_tvl) !== 'NaN'
    ? amount2NoENotation(String(_tvl), '')
    : '';
});

function handlePoolClick() {
  router.push({
    name: 'pools',
    query: {
      from: poolData.value.coinX,
      to: poolData.value.coinY,
      curve: poolData.value.curve,
      version: VERSION_0_5,
      target: 'add',
    },
  });
  window.scrollTo({ top: 0, behavior: 'smooth' });
  track(EMixpanelEventNames.BannerGoToPoolDooDoo);
}
</script>

<style lang="scss" scoped>
.doodoo-banner {
  display: flex;
  width: 100%;
  height: 84px;
  align-items: center;
  justify-content: space-around;
  position: relative;
  border-radius: 10px;
  background: #abaeff21;
  padding-left: 10px;
  padding-right: 10px;
  cursor: pointer;

  .content {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  &__item {
    z-index: 2;
  }

  &__logo {
    z-index: 2;
    margin-top: 5px;
    min-width: 90px;

    @media (max-width: 500px) {
      width: 90px;
      min-width: 65px;
    }
  }

  &__background-gradient {
    position: absolute;
    width: 100%;
    height: 84px;
  }
}

.doodoo {
  font-family: Work Sans, sans-serif;
  font-size: 26.57px;
  font-weight: 700;
  line-height: 29.36px;
  text-align: left;
  letter-spacing: 0;
  margin: 0;
  color: #c57700;

  @media (max-width: 500px) {
    font-size: 20px;
  }
}

.aptos {
  font-family: Work Sans, sans-serif;
  font-size: 26.57px;
  font-weight: 700;
  line-height: 29.36px;
  text-align: left;
  letter-spacing: 0;
  color: #ffffff;
  margin: -5px 0 0;

  @media (max-width: 500px) {
    font-size: 20px;
  }
}

.tvl-block {
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
}

.tvl {
  font-family: Work Sans, sans-serif;
  font-size: 15.95px;
  font-weight: 400;
  line-height: 17.63px;
  text-align: right;
  color: #ffffff;
  margin: 0;
}

.tvl-value {
  font-family: Roboto, sans-serif;
  font-size: 18px;
  font-weight: 900;
  line-height: 38.16px;
  letter-spacing: -0.0043em;
  text-align: right;
  background: linear-gradient(90.99deg, #aa81ff 0%, #c6aaff 103.51%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 0;

  @media (max-width: 500px) {
    font-size: 16px;
  }
}

.image-gradient {
  width: 100%;
}
</style>
